import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productRemoved: {
    id: 'checkout.cartPage.productRemoved',
    defaultMessage: 'Product was removed from your cart',
    description: 'Product removed message shown in the cart page',
  },
  undoRemoval: {
    id: 'checkout.cartPage.undoRemoval',
    defaultMessage: 'Undo removal',
    description: 'Button text to undo product removal in the cart page',
  },
});
